import { useUserStore } from '@/client/stores/user';
import { SUPER_ADMIN_ROLE } from '@/client/config/permissions';

// True when the authenticated user holds the `administrator_super` role
// (overrides every gate). Read from the session user's roles (users/info) — NOT
// the `user.admin` flag. `isLoading` holds gates closed until the user is known.
export function useIsSuperAdmin(): { isSuperAdmin: boolean; isLoading: boolean } {
  const user = useUserStore((s) => s.user);
  const isLoadingUser = useUserStore((s) => s.isLoadingUser);

  const isSuperAdmin = !!user?.roles?.some(
    (r) => r?.name?.trim().toLowerCase() === SUPER_ADMIN_ROLE
  );

  return { isSuperAdmin, isLoading: !user && isLoadingUser };
}

export default useIsSuperAdmin;
